import { render, staticRenderFns } from "./UiSlider.vue?vue&type=template&id=5d93ca40&lang=pug&"
import script from "./UiSlider.vue?vue&type=script&lang=js&"
export * from "./UiSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports